"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FetchClient3 = _interopRequireDefault(require("./_FetchClient"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var serviceUrl = 'https://baywatch.trdlnk.cimpress.io';

var BaywatchClient =
/*#__PURE__*/
function (_FetchClient2) {
  _inherits(BaywatchClient, _FetchClient2);

  function BaywatchClient(accessToken) {
    _classCallCheck(this, BaywatchClient);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaywatchClient).call(this, accessToken));
  }

  _createClass(BaywatchClient, [{
    key: "makeRandomString",
    value: function makeRandomString() {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      return text;
    }
  }, {
    key: "checkIfUserIsAlreadySetup",
    value: function checkIfUserIsAlreadySetup(sub) {
      if (!sub || sub.length === 0) {
        return Promise.resolve(false);
      }

      var url = "".concat(serviceUrl, "/v0/users/").concat(encodeURIComponent(sub), "?q=").concat(this.makeRandomString());
      var init = this.getDefaultConfig('GET');
      return fetch(url, init).then(function (response) {
        return response.status === 200;
      });
    }
  }, {
    key: "checkIfSubscriptionIsSetup",
    value: function checkIfSubscriptionIsSetup(sub, resourceUrl) {
      var url = "".concat(serviceUrl, "/v0/users/").concat(encodeURIComponent(sub), "/subscriptions/").concat(encodeURIComponent(resourceUrl), "?q=").concat(this.makeRandomString());
      var init = this.getDefaultConfig('GET');
      return fetch(url, init).then(function (response) {
        if (response.status === 200) {
          return response.json().then(function (json) {
            return json.enabled === true;
          });
        } else if (response.status === 404) {
          return false;
        } else {
          throw new Error('Unable to create subscription');
        }
      });
    }
  }, {
    key: "setSubscription",
    value: function setSubscription(sub, resourceUrl, enabled) {
      var url = "".concat(serviceUrl, "/v0/users/").concat(encodeURIComponent(sub), "/subscriptions/").concat(encodeURIComponent(resourceUrl), "?q=").concat(this.makeRandomString());
      var init = this.getDefaultConfig('PUT', {
        resourceUrl: resourceUrl,
        enabled: enabled
      });
      return fetch(url, init).then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          throw new Error('Unable to create subscription');
        }
      });
    }
  }]);

  return BaywatchClient;
}(_FetchClient3.default);

exports.default = BaywatchClient;